import { RouterProvider } from "react-router-dom";
import { browserRouter } from "@config/routeConfig";

const Pages = () => {
  return <RouterProvider router={browserRouter} />;
};

export default Pages;
